<script setup>
import { onMounted } from 'vue';
import {router} from '@inertiajs/vue3';
import Layout from "../Components/Layout.vue";

onMounted(() => {
    Telegram.WebApp.MainButton.hide();
    Telegram.WebApp.BackButton.show();
    Telegram.WebApp.BackButton.onClick(() => router.get('/'));
});
</script>

<template>
    <Layout>
        <div class="p-4 space-y-4 bg-tgThemeSecondaryBgColor">
            <!-- docs -->
            <div class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                <h3 class="text-xl font-semibold">Документы</h3>

                <ul class="mt-2 text-sm space-y-2">
                    <li class="flex space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                        <a class="border-b border-black" href="https://docs.google.com/document/d/1Xtw97MoA_3PrKHqEsRhnKAaQP39w4dNtCUyfgZwWjsg/edit?tab=t.0">Пользовательское соглашение</a>
                    </li>
                    <li class="flex space-x-2">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                        </svg>
                        <a class="border-b border-black" href="https://telegram.org/privacy-tpa">Политика конфиденциальности</a>
                    </li>
                </ul>
            </div>

            <!-- about -->
            <div class="p-6 bg-tgThemeSectionBgColor rounded-lg">
                <h3 class="text-xl font-semibold">Реквизиты</h3>

                <ul class="mt-2 text-sm space-y-2">
                    <li>ИП Шумаков Сергей Александрович</li>
                    <li>ИНН: 741207172404</li>
                    <li>ОГРНИП: 322784700284391</li>
                </ul>
            </div>
        </div>
    </Layout>
</template>
